import {
  createAsyncThunk,
  AnyAction,
  PayloadAction,
  createSlice,
} from "@reduxjs/toolkit";
import {
  AddAgentsDTO,
  CallDispositionDTO,
  ConnectOzonetelDTO,
  CreateAppTokenDTO,
  IntegrationsInitialStateDTO,
  NurturePayDTO,
  CreateMetaAddonPaymentTypes,
  EditCreditDataTypes,
  MetaContactListTypes,
} from "./types";
import {
  AddMetaAccount,
  AddMetaStream,
  AddOzonetelAgents,
  AppIntegrateToNurture,
  CallLead,
  ConnectOzonetel,
  CreateAppToken,
  DeleteMetaAccount,
  DeactivateOzonetel,
  EditMetaStream,
  GetAppToken,
  GetAppsByInstitute,
  GetMetaAccountPages,
  GetMetaAdAccount,
  GetMetaDefaultFields,
  GetMetaFields,
  GetMetaIntegratedAccounts,
  GetMetaPageForms,
  GetStreamById,
  GetStreamFieldMapping,
  GetStreams,
  InstallNurturePay,
  LeadCallDispositionForm,
  MapMetaFields,
  UninstallTokenGeneratedApp,
  UpdateMapMetaFields,
  UpdateMetaStreamStatus,
  UpdateOzonetelAgents,
  ValidateAgentId,
  CreateMetaAddonPayement,
  GetCreditMetaDistribution,
  EditCredit,
  GetStreamsForBranch,
  GetMetaContactList,
  MetaContactToLead,
  GetMetaContact_list,
  DeleteStream,
} from "./integrations.request";
import { setToastNotification } from "../../../../components/ToastNotification/service/toastNotificationSlice";

export const initialState: IntegrationsInitialStateDTO = {
  appsList: null,
  validatedAgent: null,
  appTokenData: null,
  success: false,
  error: false,
  loading: false,
  ozonetelConnectError: false,
  ozonetelConnectLoading: false,
  ozonetelConnectSuccess: false,
  deactivateOzonetelLoading: false,
  deactivateOzonetelSuccess: false,
  deactivateOzonetelError: false,
  agentAddedError: false,
  agentAddedLoading: false,
  agentAddedSuccess: false,
  validateAgentError: false,
  validateAgentLoading: false,
  validateAgentSuccess: false,
  agentUpdatedError: false,
  agentUpdatedLoading: false,
  agentUpdatedSuccess: false,
  callLeadError: false,
  callLeadLoading: false,
  callLeadSuccess: false,
  nurturePayInstalledLoading: false,
  nurturePayInstalledSuccess: false,
  nurturePayInstalledError: false,

  ozonetelWidgetShow: false,
  callDispositionLoading: false,
  callDispositionSuccess: false,
  callDispositionError: false,
  appTokenLoading: false,
  appTokenSuccess: false,
  appTokenError: false,
  appTokenGetLoading: false,
  appIntegrationloading: false,
  appIntegrationError: false,
  appIntegrationSuccess: false,
  uninstallLoading: false,
  uninstallSuccess: false,
  uninstallError: false,

  addAccountLoading: false,
  addAccountSuccess: false,
  addStreamLoading: false,
  addStreamSuccess: false,
  metaAccountsLoading: false,
  metaPagesLoading: false,
  metaAdsLoading: false,
  metaFormsLoading: false,
  metaAccounts: null,
  metaPages: null,
  metaAds: null,
  metaForms: null,
  streamsLoading: false,
  metaStreams: null,
  createdStreamId: null,
  streamLoading: false,
  metaStream: null,
  metaFieldsLoading: false,
  metaFields: null,
  metaDefaultFieldsLoading: false,
  metaDefaultFields: null,
  metaFieldMapLoading: false,
  metaFieldMapSuccess: false,
  editStreamLoading: false,
  editStreamSuccess: false,
  editMetaFieldMapLoading: false,
  editMetaFieldMapSuccess: false,
  streamByIdLoading: false,
  streamByIdSuccess: false,
  streamById: null,
  metaAddonPaymentLink: null,
  metaAddonPaymentLinkLoading: false,
  metaAddonPaymentLinkSuccess: false,
  metaAddonPaymentLinkError: false,

  metaCreditDitribution: null,
  metaCreditDitributionLoading: false,
  metaCreditDitributionSuccess: false,

  editCeditData: null,
  editCreditDataLoading: false,
  editCreditDataSuccess: false,

  metaStreamsForBranch: null,
  streamsForBranchLoading: false,
  streamsForBranchSuccess: false,

  metaContactList: null,
  metaContactListLoading: false,
  metaContactListSuccess: false,

  metaContactToLead: null,
  metaContactToLeadLoading: false,
  metaContactToLeadSuccess: false,
  metaContactToLeadError: false,

  deleteMetaAccountSuccess: false,
  deleteMetaAccountLoading: false,
  metaAccountId: null,
  streamStatusSuccess: false,
  streamStatusLoading: false,

  metaContact_list: null,
  metaContact_listLoading: false,
  metaContact_listSuccess: false,
  deleteStreamSuccess: false,
  deleteStreamLoading: false,
};

export const connectOzonetel = createAsyncThunk(
  "appIntegrations/connectOzonetel",
  async (data: ConnectOzonetelDTO, thunkAPI: any) => {
    return ConnectOzonetel(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const deactivateOzonetel = createAsyncThunk(
  "appIntegrations/deactivateOzonetel",
  async (data: any, thunkAPI: any) => {
    return DeactivateOzonetel(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const addOzonetelAgents = createAsyncThunk(
  "appIntegrations/addOzonetelAgents",
  async (data: AddAgentsDTO, thunkAPI: any) => {
    return AddOzonetelAgents(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const getAppsByInstitute = createAsyncThunk(
  "appIntegrations/getAppsByInstitute",
  async (id: string) => {
    return GetAppsByInstitute(id)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        throw e.response.data;
      });
  }
);

export const validateAgentId = createAsyncThunk(
  "appIntegrations/validateAgentId",
  async (data: any, thunkAPI: any) => {
    return ValidateAgentId(
      data.agentId,
      data.instituteId,
      data.apiKey,
      data.userName
    )
      .then((response: any) => {
        // if (response) {
        //   thunkAPI.dispatch(
        //     setToastNotification({
        //       message: response?.data?.message,
        //       type: "success",
        //       snackOpen: true,
        //     })
        //   );
        // }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        //  thunkAPI.dispatch(
        //    setToastNotification({
        //      message: e?.response?.data?.message,
        //      type: "error",
        //      snackOpen: true,
        //    })
        //  );
        throw e.response.data;
      });
  }
);

export const updateOzonetelAgents = createAsyncThunk(
  "appIntegrations/updateOzonetelAgents",
  async (data: AddAgentsDTO, thunkAPI: any) => {
    return UpdateOzonetelAgents(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const callLead = createAsyncThunk(
  "appIntegrations/callLead",
  async (data: any, thunkAPI: any) => {
    return CallLead(
      data.apiKey,
      data.userName,
      data.agentId,
      data.campaignName,
      data.leadNumber,
      data.instituteId,
      data.leadId,
      data.appEnv
    )
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        throw e.response.data;
      });
  }
);

export const installNurturePay = createAsyncThunk(
  "appIntegrations/installNurturePay",
  async (data: NurturePayDTO, thunkAPI: any) => {
    return InstallNurturePay(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const leadCallDispositionForm = createAsyncThunk(
  "appIntegrations/leadCallDispositionForm",
  async (data: CallDispositionDTO, thunkAPI: any) => {
    return LeadCallDispositionForm(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const createAppToken = createAsyncThunk(
  "appIntegrations/createAppToken",
  async (data: CreateAppTokenDTO, thunkAPI: any) => {
    return CreateAppToken(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const getAppToken = createAsyncThunk(
  "appIntegrations/getAppToken",
  async (data: any, thunkAPI: any) => {
    return GetAppToken(data.id, data.appName)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        throw e.response.data;
      });
  }
);

export const appIntegrateToNurture = createAsyncThunk(
  "appIntegrations/integration",
  async (data: any, thunkAPI: any) => {
    return AppIntegrateToNurture(data)
      .then((response: any) => {
        return response?.data;
      })
      .catch(function (e: any) {
        throw e.response.data;
      });
  }
);

export const uninstallTokenGeneratedApp = createAsyncThunk(
  "appIntegrations/uninstallTokenGeneratedApp",
  async (data: any, thunkAPI: any) => {
    return UninstallTokenGeneratedApp(data.id, data.appName)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const addMetaAccount = createAsyncThunk(
  "appIntegrations/addMetaAccount",
  async (data: any, thunkAPI: any) => {
    return AddMetaAccount(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const addMetaStream = createAsyncThunk(
  "appIntegrations/addMetaStream",
  async (data: any, thunkAPI: any) => {
    return AddMetaStream(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const editMetaStream = createAsyncThunk(
  "appIntegrations/editMetaStream",
  async (data: any, thunkAPI: any) => {
    return EditMetaStream(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const getMetaIntegratedAccounts = createAsyncThunk(
  "appIntegrations/metaAccounts",
  async (id: any, thunkAPI: any) => {
    return GetMetaIntegratedAccounts(id)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const getMetaAccountPages = createAsyncThunk(
  "appIntegrations/metaPages",
  async (data: any, thunkAPI: any) => {
    return GetMetaAccountPages(data.id, data.metaAccountId)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const getMetaAdAccount = createAsyncThunk(
  "appIntegrations/metaAds",
  async (data: any, thunkAPI: any) => {
    return GetMetaAdAccount(data.id, data.metaAccountId)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const getMetaPageForms = createAsyncThunk(
  "appIntegrations/metaForms",
  async (data: any, thunkAPI: any) => {
    return GetMetaPageForms(data.id, data.metaAccountId, data.pageId)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const getStreams = createAsyncThunk(
  "appIntegrations/getStreams",
  async (data: any, thunkAPI: any) => {
    return GetStreams(data.id, data.status, data.branchId)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const getStreamsForBranch = createAsyncThunk(
  "appIntegrations/getStreamsForBranch",
  async (data: string, thunkAPI: any) => {
    return GetStreamsForBranch(data)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const getStreamFieldMapping = createAsyncThunk(
  "appIntegrations/getStreamFieldMapping",
  async (data: any, thunkAPI: any) => {
    return GetStreamFieldMapping(data.id, data.streamId)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const getMetaFields = createAsyncThunk(
  "appIntegrations/getMetaFields",
  async (data: any, thunkAPI: any) => {
    return GetMetaFields(data.streamId)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const getMetaDefaultFields = createAsyncThunk(
  "appIntegrations/getMetaDefaultFields",
  async (thunkAPI: any) => {
    return GetMetaDefaultFields()
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const createMetaAddonPaymentLink = createAsyncThunk(
  "appIntegrations/createMetaAddonPaymentLink",
  async (data: CreateMetaAddonPaymentTypes, thunkAPI: any) => {
    return CreateMetaAddonPayement(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const getCreditDitribution = createAsyncThunk(
  "appIntegrations/creditDistribution",
  async (data: string, thunkAPI: any) => {
    return GetCreditMetaDistribution(data)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        throw e.response.data;
      });
  }
);

export const editCreditData = createAsyncThunk(
  "appIntegrations/editCreditData",
  async (data: EditCreditDataTypes, thunkAPI: any) => {
    return EditCredit(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);
export const mapMetaFields = createAsyncThunk(
  "appIntegrations/mapMetaFields",
  async (data: any, thunkAPI: any) => {
    return MapMetaFields(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const updateMapedMetaFields = createAsyncThunk(
  "appIntegrations/updatemapMetaFields",
  async (data: any, thunkAPI: any) => {
    return UpdateMapMetaFields(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const getStreamById = createAsyncThunk(
  "appIntegrations/getStreamById",
  async (streamId: any, thunkAPI: any) => {
    return GetStreamById(streamId)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const getMetaContactList = createAsyncThunk(
  "appIntegrations/getMetaContactList",
  async (data: MetaContactListTypes, thunkAPI: any) => {
    return GetMetaContactList(data)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const metaContactToLead = createAsyncThunk(
  "appIntegrations/metaContactToLead",
  async (data: any, thunkAPI: any) => {
    return MetaContactToLead(data)
      .then((response: any) => {
        thunkAPI.dispatch(
          setToastNotification({
            message: response?.data?.message,
            type: "success",
            snackOpen: true,
          })
        );
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const deleteMetaAccount = createAsyncThunk(
  "appIntegrations/deleteMetaAccount",
  async (data: any, thunkAPI: any) => {
    return DeleteMetaAccount(data?.id, data?.accountId)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const updateMetaStreamStatus = createAsyncThunk(
  "appIntegrations/streamStatus",
  async (data: any, thunkAPI: any) => {
    return UpdateMetaStreamStatus(data?.status, data?.streamId)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const getMetaContact_List = createAsyncThunk(
  "appIntegrations/getMetaContact_List",
  async (data: any, thunkAPI: any) => {
    return GetMetaContact_list(data)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const deleteStream = createAsyncThunk(
  "appIntegrations/deleteStream",
  async (streamId: any, thunkAPI: any) => {
    return DeleteStream(streamId)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const integrationsSlice = createSlice({
  name: "integrations",
  initialState,
  reducers: {
    reset: () => initialState,
    resetOzonetelConnectStatuses: (state) => {
      state.ozonetelConnectSuccess = false;
      state.ozonetelConnectError = false;
    },
    resetDeactivateConnectStatuses: (state) => {
      state.deactivateOzonetelSuccess = false;
      state.deactivateOzonetelError = false;
    },
    resetAgentStatuses: (state) => {
      state.agentAddedSuccess = false;
      state.agentAddedError = false;
      state.agentUpdatedSuccess = false;
      state.agentUpdatedError = false;
    },
    resetNurturePayConnectStatuses: (state) => {
      state.nurturePayInstalledSuccess = false;
      state.nurturePayInstalledError = false;
    },
    setShowOzonetelWidget: (state) => {
      state.ozonetelWidgetShow = true;
    },
    setHideOzonetelWidget: (state) => {
      state.ozonetelWidgetShow = false;
    },
    resetCallDispositionFormStatuses: (state) => {
      state.callDispositionSuccess = false;
      state.callDispositionError = false;
    },
    resetUninstallStatuses: (state) => {
      state.uninstallError = false;
      state.uninstallSuccess = false;
    },
    resetAppTokenStatuses: (state) => {
      state.appTokenSuccess = false;
      state.appTokenError = false;
    },
    resetStreamById: (state) => {
      state.streamById = null;
      state.streamByIdLoading = false;
      state.streamByIdSuccess = false;
    },
    resetMetaContactList: (state) => {
      state.metaContactList = null;
      state.metaContactListLoading = false;
      state.metaContactListSuccess = false;
    },
    resetMetaStatuses: (state) => {
      state.addAccountSuccess = false;
      state.addStreamSuccess = false;
      state.createdStreamId = null;
      state.editMetaFieldMapSuccess = false;
      state.editStreamSuccess = false;
      state.deleteMetaAccountSuccess = false; //
      state.metaAccountId = null;
      state.streamStatusSuccess = false;
      state.deleteStreamSuccess = false;
    },
    resetMetaStreamById: (state) => {
      state.streamById = null;
    },
    resetMetaSuccess: (state) => {
      state.metaContactToLeadSuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(
      validateAgentId.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.validateAgentLoading = false;
        state.validateAgentSuccess = true;
        state.validateAgentError = false;
        state.validatedAgent = action?.payload;
      }
    );
    builder.addCase(validateAgentId.rejected, (state, action: AnyAction) => {
      state.validateAgentLoading = false;
      state.validateAgentSuccess = false;
      state.validateAgentError =
        action?.error?.message || "Something went wrong";
    });
    builder.addCase(validateAgentId.pending, (state) => {
      state.validateAgentLoading = true;
      state.validateAgentSuccess = false;
      state.validateAgentError = false;
    });
    builder.addCase(
      getAppsByInstitute.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.success = true;
        state.error = false;
        state.appsList = action?.payload;
      }
    );
    builder.addCase(getAppsByInstitute.rejected, (state, action: AnyAction) => {
      state.loading = false;
      state.success = false;
      state.error = action?.error?.message || "Something went wrong";
    });
    builder.addCase(getAppsByInstitute.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = false;
    });

    builder.addCase(updateOzonetelAgents.pending, (state) => {
      state.agentUpdatedLoading = true;
      state.agentUpdatedSuccess = false;
      state.agentUpdatedError = false;
    });
    builder.addCase(
      updateOzonetelAgents.fulfilled,
      (state, action: AnyAction) => {
        state.agentUpdatedLoading = false;
        state.agentUpdatedSuccess =
          action?.success?.message || "Ozonetel agents updated successfully!";
        state.agentUpdatedError = false;
      }
    );
    builder.addCase(
      updateOzonetelAgents.rejected,
      (state, action: AnyAction) => {
        state.agentUpdatedLoading = false;
        state.agentUpdatedSuccess = false;
        state.agentUpdatedError =
          action?.error?.message || "Something went wrong";
      }
    );
    builder.addCase(callLead.pending, (state) => {
      state.agentAddedLoading = true;
      state.agentAddedSuccess = false;
      state.agentAddedError = false;
    });
    builder.addCase(callLead.fulfilled, (state, action: AnyAction) => {
      state.agentAddedLoading = false;
      state.agentAddedSuccess =
        action?.success?.message || "Ozonetel agents added successfully!";
      state.agentAddedError = false;
    });
    builder.addCase(callLead.rejected, (state, action: AnyAction) => {
      state.agentAddedLoading = false;
      state.agentAddedSuccess = false;
      state.agentAddedError = action?.error?.message || "Something went wrong";
    });

    builder.addCase(installNurturePay.pending, (state) => {
      state.nurturePayInstalledLoading = true;
      state.nurturePayInstalledSuccess = false;
      state.nurturePayInstalledError = false;
    });
    builder.addCase(installNurturePay.fulfilled, (state, action: AnyAction) => {
      state.nurturePayInstalledLoading = false;
      state.nurturePayInstalledSuccess =
        action?.success?.message || "Request Successfully Registered!";
      state.nurturePayInstalledError = false;
    });
    builder.addCase(installNurturePay.rejected, (state, action: AnyAction) => {
      state.callDispositionLoading = false;
      state.callDispositionSuccess = false;
      state.callDispositionError =
        action?.error?.message || "Something went wrong";
    });
    builder.addCase(leadCallDispositionForm.pending, (state) => {
      state.callDispositionLoading = true;
      state.callDispositionSuccess = false;
      state.callDispositionError = false;
    });
    builder.addCase(
      leadCallDispositionForm.fulfilled,
      (state, action: AnyAction) => {
        state.callDispositionLoading = false;
        state.callDispositionSuccess =
          action?.success?.message || "Disposition added";
        state.callDispositionError = false;
      }
    );
    builder.addCase(
      leadCallDispositionForm.rejected,
      (state, action: AnyAction) => {
        state.nurturePayInstalledLoading = false;
        state.nurturePayInstalledSuccess = false;
        state.nurturePayInstalledError =
          action?.error?.message || "Something went wrong";
      }
    );
    builder.addCase(createAppToken.pending, (state) => {
      state.appTokenLoading = true;
      state.appTokenSuccess = false;
      state.appTokenError = false;
    });
    builder.addCase(createAppToken.fulfilled, (state, action: AnyAction) => {
      state.appTokenLoading = false;
      state.appTokenSuccess =
        action?.payload?.message || "App token connected successfully!";
      state.appTokenError = false;
    });
    builder.addCase(createAppToken.rejected, (state, action: AnyAction) => {
      state.appTokenLoading = false;
      state.appTokenSuccess = false;
      state.appTokenError = action?.error?.message || "Something went wrong";
    });
    builder.addCase(getAppToken.pending, (state) => {
      state.appTokenGetLoading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(
      getAppToken.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.appTokenGetLoading = false;
        state.success = true;
        state.error = false;
        state.appTokenData = action?.payload;
      }
    );
    builder.addCase(getAppToken.rejected, (state, action: AnyAction) => {
      state.appTokenGetLoading = false;
      state.success = false;
      state.error = action?.error?.message || "Something went wrong";
    });
    builder.addCase(appIntegrateToNurture.pending, (state) => {
      state.appIntegrationloading = true;
      state.appIntegrationError = false;
      state.appIntegrationSuccess = false;
    });
    builder.addCase(
      appIntegrateToNurture.fulfilled,
      (state, action: AnyAction) => {
        state.appIntegrationloading = false;
        state.appIntegrationSuccess =
          action?.success?.message || "App integrated successfully!";
        state.appIntegrationError = false;
      }
    );
    builder.addCase(
      appIntegrateToNurture.rejected,
      (state, action: AnyAction) => {
        state.appIntegrationloading = false;
        state.appIntegrationSuccess = false;
        state.appIntegrationError =
          action?.error?.message || "Something went wrong";
      }
    );
    builder.addCase(uninstallTokenGeneratedApp.pending, (state) => {
      state.uninstallLoading = true;
      state.uninstallSuccess = false;
      state.uninstallError = false;
    });
    builder.addCase(
      uninstallTokenGeneratedApp.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.uninstallLoading = false;
        state.uninstallSuccess =
          action?.payload?.message || "App uninstalled successfully!";
        state.uninstallError = false;
      }
    );
    builder.addCase(
      uninstallTokenGeneratedApp.rejected,
      (state, action: AnyAction) => {
        state.uninstallLoading = false;
        state.uninstallSuccess = false;
        state.uninstallError = action?.error?.message || "Something went wrong";
      }
    );

    builder.addCase(getMetaAccountPages.pending, (state) => {
      state.metaPagesLoading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(
      getMetaAccountPages.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.metaPagesLoading = false;
        state.success = true;
        state.error = false;
        state.metaPages = action?.payload;
      }
    );
    builder.addCase(
      getMetaAccountPages.rejected,
      (state, action: AnyAction) => {
        state.metaPagesLoading = false;
        state.success = false;
        state.error = action?.error?.message || "Something went wrong";
      }
    );

    builder.addCase(getMetaAdAccount.pending, (state) => {
      state.metaAdsLoading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(
      getMetaAdAccount.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.metaAdsLoading = false;
        state.success = true;
        state.error = false;
        state.metaAds = action?.payload;
      }
    );
    builder.addCase(getMetaAdAccount.rejected, (state, action: AnyAction) => {
      state.metaAdsLoading = false;
      state.success = false;
      state.error = action?.error?.message || "Something went wrong";
    });

    builder.addCase(getMetaPageForms.pending, (state) => {
      state.metaFormsLoading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(
      getMetaPageForms.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.metaFormsLoading = false;
        state.success = true;
        state.error = false;
        state.metaForms = action?.payload;
      }
    );
    builder.addCase(getMetaPageForms.rejected, (state, action: AnyAction) => {
      state.metaFormsLoading = false;
      state.success = false;
      state.error = action?.error?.message || "Something went wrong";
    });

    builder.addCase(connectOzonetel.pending, (state) => {
      state.ozonetelConnectLoading = true;
      state.ozonetelConnectSuccess = false;
      state.ozonetelConnectError = false;
    });
    builder.addCase(connectOzonetel.fulfilled, (state, action: AnyAction) => {
      state.ozonetelConnectLoading = false;
      state.ozonetelConnectSuccess =
        action?.success?.message || "Ozonetel account connected successfully!";
      //   state.ozonetelConnectSuccess = action?.success?.message;
      state.ozonetelConnectError = false;
    });
    builder.addCase(connectOzonetel.rejected, (state, action: AnyAction) => {
      state.ozonetelConnectLoading = false;
      state.ozonetelConnectSuccess = false;
      state.ozonetelConnectError =
        action?.error?.message || "Something went wrong";
    });
    builder.addCase(deactivateOzonetel.pending, (state) => {
      state.deactivateOzonetelLoading = true;
      state.deactivateOzonetelSuccess = false;
      state.deactivateOzonetelError = false;
    });
    builder.addCase(
      deactivateOzonetel.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.deactivateOzonetelLoading = false;
        state.deactivateOzonetelSuccess = true;
        state.deactivateOzonetelError = false;
      }
    );
    builder.addCase(deactivateOzonetel.rejected, (state, action: AnyAction) => {
      state.deactivateOzonetelLoading = false;
      state.deactivateOzonetelSuccess = false;
      state.deactivateOzonetelError =
        action?.error?.message || "Something went wrong";
    });
    builder.addCase(addOzonetelAgents.pending, (state) => {
      state.agentAddedLoading = true;
      state.agentAddedSuccess = false;
      state.agentAddedError = false;
    });
    builder.addCase(addOzonetelAgents.fulfilled, (state, action: AnyAction) => {
      state.agentAddedLoading = false;
      state.agentAddedSuccess =
        action?.success?.message || "Ozonetel agents added successfully!";
      state.agentAddedError = false;
    });
    builder.addCase(addOzonetelAgents.rejected, (state, action: AnyAction) => {
      state.agentAddedLoading = false;
      state.agentAddedSuccess = false;
      state.agentAddedError = action?.error?.message || "Something went wrong";
    });

    builder.addCase(getStreams.pending, (state) => {
      state.streamsLoading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(
      getStreams.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.streamsLoading = false;
        state.success = true;
        state.error = false;
        state.metaStreams = action?.payload;
      }
    );
    builder.addCase(getStreams.rejected, (state, action: AnyAction) => {
      state.streamsLoading = false;
      state.success = false;
      state.error = action?.error?.message || "Something went wrong";
    });

    builder.addCase(getStreamsForBranch.pending, (state) => {
      state.streamsForBranchLoading = true;
      state.streamsForBranchSuccess = false;
      state.error = false;
    });
    builder.addCase(
      getStreamsForBranch.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.streamsForBranchLoading = false;
        state.streamsForBranchSuccess = true;
        state.error = false;
        state.metaStreamsForBranch = action?.payload;
      }
    );
    builder.addCase(
      getStreamsForBranch.rejected,
      (state, action: AnyAction) => {
        state.streamsForBranchLoading = false;
        state.streamsForBranchSuccess = false;
        state.error = action?.error?.message || "Something went wrong";
      }
    );

    builder.addCase(getMetaFields.pending, (state) => {
      state.metaFieldsLoading = true;
      state.streamsForBranchSuccess = false;
      state.error = false;
    });
    builder.addCase(
      getMetaFields.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.metaFieldsLoading = false;
        state.success = true;
        state.error = false;
        state.metaFields = action?.payload;
      }
    );
    builder.addCase(getMetaFields.rejected, (state, action: AnyAction) => {
      state.metaFieldsLoading = false;
      state.success = false;
      state.error = action?.error?.message || "Something went wrong";
    });
    builder.addCase(getMetaDefaultFields.pending, (state) => {
      state.metaDefaultFieldsLoading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(
      getMetaDefaultFields.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.metaDefaultFieldsLoading = false;
        state.success = true;
        state.error = false;
        state.metaDefaultFields = action?.payload;
      }
    );
    builder.addCase(
      getMetaDefaultFields.rejected,
      (state, action: AnyAction) => {
        state.metaDefaultFieldsLoading = false;
        state.success = false;
        state.error = action?.error?.message || "Something went wrong";
      }
    );

    builder.addCase(mapMetaFields.pending, (state) => {
      state.metaFieldMapLoading = true;
      state.metaFieldMapSuccess = false;
      state.error = false;
    });
    builder.addCase(mapMetaFields.fulfilled, (state, action: AnyAction) => {
      state.metaFieldMapLoading = false;
      state.metaFieldMapSuccess =
        action?.success?.message || "Meta fields mapped successfully!";
      state.error = false;
    });
    builder.addCase(mapMetaFields.rejected, (state, action: AnyAction) => {
      state.metaFieldMapLoading = false;
      state.metaFieldMapSuccess = false;
      state.error = action?.error?.message || "Something went wrong";
    });
    builder.addCase(updateMapedMetaFields.pending, (state) => {
      state.editMetaFieldMapLoading = true;
      state.editMetaFieldMapSuccess = false;
      state.error = false;
    });
    builder.addCase(
      updateMapedMetaFields.fulfilled,
      (state, action: AnyAction) => {
        state.editMetaFieldMapLoading = false;
        state.editMetaFieldMapSuccess =
          action?.success?.message || "Meta fields mapped successfully!";
        state.error = false;
      }
    );
    builder.addCase(
      updateMapedMetaFields.rejected,
      (state, action: AnyAction) => {
        state.editMetaFieldMapLoading = false;
        state.editMetaFieldMapSuccess = false;
        state.error = action?.error?.message || "Something went wrong";
      }
    );
    builder.addCase(addMetaAccount.pending, (state) => {
      state.addAccountLoading = true;
      state.addAccountSuccess = false;
      state.error = false;
    });
    builder.addCase(addMetaAccount.fulfilled, (state, action: AnyAction) => {
      state.addAccountLoading = false;
      state.addAccountSuccess =
        action?.success?.message || "Meta account added successfully!";
      state.error = false;
      state.metaAccountId = action?.payload?.data?.id;
    });
    builder.addCase(addMetaAccount.rejected, (state, action: AnyAction) => {
      state.addAccountLoading = false;
      state.addAccountSuccess = false;
      state.error = action?.error?.message || "Something went wrong";
    });
    builder.addCase(addMetaStream.pending, (state) => {
      state.addStreamLoading = true;
      state.addStreamSuccess = false;
      state.error = false;
    });
    builder.addCase(addMetaStream.fulfilled, (state, action: AnyAction) => {
      state.addStreamLoading = false;
      state.addStreamSuccess =
        action?.success?.message || "Stream added successfully!";
      state.error = false;
      state.createdStreamId = action?.payload?.data?.id;
    });
    builder.addCase(addMetaStream.rejected, (state, action: AnyAction) => {
      state.addStreamLoading = false;
      state.addStreamSuccess = false;
      state.error = action?.error?.message || "Something went wrong";
    });
    builder.addCase(editMetaStream.pending, (state) => {
      state.editStreamLoading = true;
      state.editStreamSuccess = false;
      state.error = false;
    });
    builder.addCase(editMetaStream.fulfilled, (state, action: AnyAction) => {
      state.editStreamLoading = false;
      state.editStreamSuccess =
        action?.success?.message || "Stream added successfully!";
      state.error = false;
      state.createdStreamId = action?.payload?.data?.id;
    });
    builder.addCase(editMetaStream.rejected, (state, action: AnyAction) => {
      state.editStreamLoading = false;
      state.editStreamSuccess = false;
      state.error = action?.error?.message || "Something went wrong";
    });
    builder.addCase(getMetaIntegratedAccounts.pending, (state) => {
      state.metaAccountsLoading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(
      getMetaIntegratedAccounts.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.metaAccountsLoading = false;
        state.success = true;
        state.error = false;
        state.metaAccounts = action?.payload;
      }
    );
    builder.addCase(
      getMetaIntegratedAccounts.rejected,
      (state, action: AnyAction) => {
        state.metaAccountsLoading = false;
        state.success = false;
        state.error = action?.error?.message || "Something went wrong";
      }
    );

    builder.addCase(
      createMetaAddonPaymentLink.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.metaAddonPaymentLinkLoading = false;
        state.metaAddonPaymentLinkSuccess = true;
        state.metaAddonPaymentLinkError = false;
        state.metaAddonPaymentLink = action?.payload;
      }
    );
    builder.addCase(
      createMetaAddonPaymentLink.rejected,
      (state, action: AnyAction) => {
        state.metaAddonPaymentLinkLoading = false;
        state.metaAddonPaymentLinkSuccess = false;
        state.error = action?.error?.message || "Something went wrong";
      }
    );
    builder.addCase(createMetaAddonPaymentLink.pending, (state) => {
      state.metaAddonPaymentLinkLoading = true;
      state.metaAddonPaymentLinkSuccess = false;
      state.metaAddonPaymentLinkError = false;
    });

    builder.addCase(getStreamFieldMapping.pending, (state) => {
      state.streamLoading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(
      getStreamFieldMapping.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.streamLoading = false;
        state.success = true;
        state.error = false;
        state.metaStream = action?.payload;
      }
    );
    builder.addCase(
      getStreamFieldMapping.rejected,
      (state, action: AnyAction) => {
        state.streamLoading = false;
        state.success = false;
        state.error = action?.error?.message || "Something went wrong";
      }
    );

    builder.addCase(
      getCreditDitribution.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.metaCreditDitributionLoading = false;
        state.metaCreditDitributionSuccess = true;
        state.error = false;
        state.metaCreditDitribution = action?.payload;
      }
    );
    builder.addCase(
      getCreditDitribution.rejected,
      (state, action: AnyAction) => {
        state.metaCreditDitributionLoading = false;
        state.metaCreditDitributionSuccess = false;
        state.error = action?.error?.message || "Something went wrong";
      }
    );
    builder.addCase(getCreditDitribution.pending, (state) => {
      state.metaCreditDitributionLoading = true;
      state.metaCreditDitributionSuccess = false;
      state.error = false;
    });

    builder.addCase(
      editCreditData.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.editCreditDataLoading = false;
        state.editCreditDataSuccess = true;
        state.error = false;
      }
    );
    builder.addCase(editCreditData.rejected, (state, action: AnyAction) => {
      state.editCreditDataLoading = false;
      state.editCreditDataSuccess = false;
      state.error = action?.error?.message || "Something went wrong";
    });
    builder.addCase(editCreditData.pending, (state) => {
      state.editCreditDataLoading = true;
      state.editCreditDataSuccess = false;
      state.error = false;
    });

    builder.addCase(getStreamById.pending, (state) => {
      state.streamByIdLoading = true;
      state.streamByIdSuccess = false;
      state.error = false;
    });
    builder.addCase(
      getStreamById.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.streamByIdLoading = false;
        state.streamByIdSuccess = true;
        state.error = false;
        state.streamById = action?.payload;
      }
    );
    builder.addCase(getStreamById.rejected, (state, action: AnyAction) => {
      state.streamByIdLoading = false;
      state.streamByIdSuccess = false;
      state.error = action?.error?.message || "Something went wrong";
    });

    builder.addCase(getMetaContactList.pending, (state) => {
      state.metaContactListLoading = true;
      state.metaContactListSuccess = false;
      state.error = false;
    });
    builder.addCase(
      getMetaContactList.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.metaContactListLoading = false;
        state.metaContactListSuccess = true;
        state.error = false;
        state.metaContactList = action?.payload;
      }
    );
    builder.addCase(getMetaContactList.rejected, (state, action: AnyAction) => {
      state.metaContactListLoading = false;
      state.metaContactListSuccess = false;
      state.error = action?.error?.message || "Something went wrong";
    });

    builder.addCase(metaContactToLead.pending, (state) => {
      state.metaContactToLeadLoading = true;
      state.metaContactToLeadSuccess = false;
      state.metaContactToLeadError = false;
    });
    builder.addCase(
      metaContactToLead.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.metaContactToLeadLoading = false;
        state.metaContactToLeadSuccess = true;
        state.metaContactToLeadError = false;
        state.metaContactToLead = action?.payload;
      }
    );
    builder.addCase(metaContactToLead.rejected, (state, action: AnyAction) => {
      state.metaContactToLeadLoading = false;
      state.metaContactToLeadSuccess = false;
      state.metaContactToLeadError =
        action?.error?.message || "Something went wrong";
    });

    builder.addCase(deleteMetaAccount.pending, (state) => {
      state.deleteMetaAccountLoading = true;
      state.deleteMetaAccountSuccess = false;
      state.error = false;
    });

    builder.addCase(deleteMetaAccount.fulfilled, (state, action: AnyAction) => {
      state.deleteMetaAccountLoading = false;
      state.deleteMetaAccountSuccess =
        action?.payload?.message || "Meta account deleted Successfully";
      state.error = false;
    });
    builder.addCase(deleteMetaAccount.rejected, (state, action: AnyAction) => {
      state.deleteMetaAccountLoading = false;
      state.deleteMetaAccountSuccess = false;
      state.error = action?.error?.message || "Something went wrong";
    });
    builder.addCase(updateMetaStreamStatus.pending, (state) => {
      state.streamStatusLoading = true;
      state.streamStatusSuccess = false;
      state.error = false;
    });
    builder.addCase(
      updateMetaStreamStatus.fulfilled,
      (state, action: AnyAction) => {
        state.streamStatusLoading = false;
        state.streamStatusSuccess =
          action?.success?.message || "Stream status updated successfully!";
        state.error = false;
      }
    );
    builder.addCase(
      updateMetaStreamStatus.rejected,
      (state, action: AnyAction) => {
        state.streamStatusLoading = false;
        state.streamStatusSuccess = false;
        state.error = action?.error?.message || "Something went wrong";
      }
    );

    builder.addCase(getMetaContact_List.pending, (state) => {
      state.metaContact_listLoading = true;
      state.metaContact_listSuccess = false;
      state.error = false;
    });
    builder.addCase(
      getMetaContact_List.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.metaContact_listLoading = false;
        state.metaContact_listSuccess = true;
        state.error = false;
        state.metaContact_list = action?.payload;
      }
    );
    builder.addCase(
      getMetaContact_List.rejected,
      (state, action: AnyAction) => {
        state.metaContact_listLoading = false;
        state.metaContact_listSuccess = false;
        state.error = action?.error?.message || "Something went wrong";
      }
    );
    builder.addCase(deleteStream.pending, (state) => {
      state.deleteStreamLoading = true;
      state.deleteStreamSuccess = false;
      state.error = false;
    });

    builder.addCase(deleteStream.fulfilled, (state, action: AnyAction) => {
      state.deleteStreamLoading = false;
      state.deleteStreamSuccess =
        action?.payload?.message || "Stream deleted Successfully";
      state.error = false;
    });
    builder.addCase(deleteStream.rejected, (state, action: AnyAction) => {
      state.deleteStreamLoading = false;
      state.deleteStreamSuccess = false;
      state.error = action?.error?.message || "Something went wrong";
    });
  },
});

export default integrationsSlice.reducer;
export const {
  reset,
  resetOzonetelConnectStatuses,
  resetDeactivateConnectStatuses,
  resetAgentStatuses,
  setShowOzonetelWidget,
  setHideOzonetelWidget,
  resetNurturePayConnectStatuses,
  resetCallDispositionFormStatuses,
  resetUninstallStatuses,
  resetAppTokenStatuses,
  resetMetaStatuses,
  resetMetaStreamById,
  resetStreamById,
  resetMetaContactList,
} = integrationsSlice.actions;
